import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ILoginCallbackRequest, ILoginCallbackResponse } from "src/services";
import { IAppContext } from "../withAppContext";
import withAxios, { IAxiosProps } from "../withAxios";
import { getNavigationHistory } from "src/hooks/useNavigationHistory";

export default withAxios(
  class GoogleCallback extends React.Component<
    IAxiosProps & IAppContext & RouteComponentProps<any>
  > {
    public async componentDidMount() {
      const code = this.props.location.search
        .substring(1)
        .split("&")
        .filter((p) => /^code=/.test(p))
        .map((p) => decodeURIComponent(p.substring("code=".length)))[0];
      const data: ILoginCallbackRequest = {
        code,
      };
      const response = (
        await this.props.axios.post<ILoginCallbackResponse>(
          "sign-in/google/callback",
          data
        )
      ).data;
      console.log("response.user---------<",response.user)
      if (response.user?.id) {
        this.props.removeNewUserDetails()
        this.props.userChanged(response.user);
        this.props.changeIsNewUser(false);
        try { localStorage.setItem("userId", String(response.user.id)); } catch { /* noop */ }
      } else if (response.data?.email) {
        this.props.removeNewUserDetails()
        this.props.userChanged(response.data);
        this.props.changeIsNewUser(true);
      }
      // Redirect using navigation history (same logic as login)
      const historyArr = getNavigationHistory();
      // const lastPath = historyArr[historyArr.length - 3];
      // if (lastPath?.includes("dashboard")) {
      //   console.log("Redirecting to dashboard:", lastPath);
      //   this.props.history.push(lastPath);
      // } else {
      //   console.log("Redirecting to home (no dashboard path found)");
      //   this.props.history.push("/");
      // }

      // =============================
      // const historyArr = getNavigationHistory();

// check last 2,3,4 paths
console.log("historyArr for google callback",historyArr)
const checkIndexes = [2, 3, 4]; 
let redirectPath = null;

for (const i of checkIndexes) {
  const candidate = historyArr[historyArr.length - i];
  if (candidate?.includes("dashboard")) {
    redirectPath = candidate;
    break; // stop at first match
  }
}

if (redirectPath) {
  console.log("Redirecting to dashboard:", redirectPath);
  this.props.history.push(redirectPath);
} else {
  console.log("Redirecting to home (no dashboard path found)");
  this.props.history.push("/");
}
      // =============================
      // this.props.history.push("/admin/templates");
    }

    public render() {
      return null;
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/login/GoogleCallback.tsx